import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type Unit = {
  unitid: string;
  unitpid: string;
  unitcode: string;
  unitdescription: string;
  lumenaversion: 'edge' | 'legacy';
};

const getUnits = async (
  searchQuery?: string,
  page?: number,
  limit?: number,
): Promise<{ units: Unit[]; totalPages: number }> => {
  const params = new URLSearchParams();
  if (searchQuery) params.set('q', searchQuery);
  if (limit !== undefined) params.set('limit', String(limit));
  if (page !== undefined) params.set('page', String(page));
  const response = await fetch(`/api/units?${params}`);
  return response.json();
};

export const UNITS_QUERY_KEY = 'units';

export const useUnits = ({
  searchQuery,
  page,
  limit = 5,
}: {
  searchQuery?: string;
  page?: number;
  limit?: number;
}) =>
  useQuery({
    queryKey: [UNITS_QUERY_KEY, searchQuery, page, limit],
    queryFn: () => getUnits(searchQuery, page, limit),
    placeholderData: keepPreviousData,
  });
